import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('log', log);

    /**
     * Service for manually logging to the server and the JavaScript console.
     *
     * @see http://engineering.talis.com/articles/client-side-error-logging/
     * @ngInject
     */
    function log($log) {
        return {
            error: error,
            debug: debug
        };

        function error() {
            // Preserve the default behavior of Angular's exception handling:
            // Log to client's JavaScript console and keep the app running.
            $log.error.apply($log, arguments);
        }

        function debug() {
            // Preserve the default behavior of Angular's exception handling:
            // Log to client's JavaScript console and keep the app running.
            $log.log.apply($log, arguments);
        }
    }
})();
